import { ReactNode } from "react";
import { Button, Card } from "react-bootstrap";
import SmallSpinner from "@components/SmallSpinner/SmallSpinner";
import "./CatalogIndex.css";

export interface AdminFormPageProps {
  title: string;
  formId: string;
  /** Omit to render no Cancel button — e.g. a page with nowhere to go back to. */
  onCancel?: () => void;
  onSaveAndAddAnother?: () => void;
  isSubmitting?: boolean;
  saveLabel?: string;
  cancelLabel?: string;
  children: ReactNode;
}

export const AdminFormPage = ({
  title,
  formId,
  onCancel,
  onSaveAndAddAnother,
  isSubmitting = false,
  saveLabel = "Save",
  cancelLabel = "Cancel",
  children,
}: AdminFormPageProps) => {
  return (
    <div className="admin-form-card">
      <Card>
        <Card.Header>
          <div className="admin-form-card__row">
            <div
              className={
                onCancel
                  ? "admin-form-card__title-group"
                  : "admin-form-card__title-group admin-form-card__title-group--no-cancel"
              }
            >
              {onCancel && (
                <Button
                  className="btnSeawhite"
                  type="button"
                  onClick={onCancel}
                  disabled={isSubmitting}
                >
                  {cancelLabel}
                </Button>
              )}
              <span className="adminFormCardTitle">{title}</span>
            </div>
            <div className="admin-form-card__actions">
              {onSaveAndAddAnother && (
                <Button
                  data-testid="save-and-add-another-button"
                  className="btnSeawhite"
                  type="button"
                  onClick={onSaveAndAddAnother}
                  disabled={isSubmitting}
                >
                  {isSubmitting ? <SmallSpinner /> : "Save and Add Another"}
                </Button>
              )}
              <Button
                data-testid="save-button"
                className="squareGreenButton"
                type="submit"
                form={formId}
                disabled={isSubmitting}
              >
                {isSubmitting ? <SmallSpinner /> : saveLabel}
              </Button>
            </div>
          </div>
          <hr />
        </Card.Header>
        <Card.Body style={{ padding: "0px 16px 16px 16px" }}>
          {children}
        </Card.Body>
      </Card>
    </div>
  );
};
